/**
 * Production-safe logger utility
 * Prevents console logs from appearing in production environment
 */

const isProduction = import.meta.env.VITE_APP_ENV === 'production';

export const logger = {
  log: (...args: unknown[]) => {
    if (!isProduction) {
      console.log(...args);
    }
  },

  error: (...args: unknown[]) => {
    if (!isProduction) {
      console.error(...args);
    }
  },

  warn: (...args: unknown[]) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },

  info: (...args: unknown[]) => {
    if (!isProduction) {
      console.info(...args);
    }
  },

  debug: (...args: unknown[]) => {
    if (!isProduction) {
      console.debug(...args);
    }
  },
};

// For backward compatibility, export individual functions
export const { log, error, warn, info, debug } = logger;

// Default export
export default logger;
